<template>
  <v-layout fill-height column class="survey-result">
    <!-- 검사 결과 탭 -->
    <v-container fluid class="pb-0">
      <v-btn-toggle v-if="showTravelBtn"
                    v-model="travelApplStepCd"
                    group dense color="primary"
                    mandatory
                    class="btn-toggle-input-group d-flex w-100">
        <v-btn depressed outlined :ripple="false"
               active-class="active"
               class="flex-grow-1"
               value="0001"
               @click="goTravelPage('S','0001')"
        >사전검사</v-btn>
        <v-btn depressed outlined :ripple="false"
               active-class="active"
               class="flex-grow-1"
               value="0002"
               @click="goTravelPage('S','0002')"
               v-if="travelHistoryList.filter(t => t.travelApplStepCd === '0002').length > 0"
        >중간검사</v-btn>
        <v-btn depressed outlined :ripple="false"
               active-class="active"
               class="flex-grow-1"
               value="0003"
               @click="goTravelPage('S','0003')"
               v-if="travelHistoryList.filter(t => t.travelApplStepCd === '0003').length > 0"
        >사후검사</v-btn>
      </v-btn-toggle>
      <v-alert type="" color="primary" rounded="xl" dense text class="mb-0">
        <div class="text-center fs-md">
          <v-icon color="primary" small>mdi-information-outline</v-icon>
          검사 시행일 : {{regDt}}
        </div>
      </v-alert>
    </v-container>
    <!-- 검사 결과 탭 -->

    <v-container fluid>

      <div class="survey-result-summary">
        요즘 {{ nickname }}님의<br/>
        <b>
          마음날씨는 <span>{{ state }}</span> 이며,<br/>
          마음 속에 <span>{{ tree }}</span>가 자라나고 <br>
          있습니다.
        </b>
      </div>

      <div class="tree-area weather-area">
        <Tree class="icon-tree" v-if="treeUrl != ''" :treeSrc="treeUrl"/>
        <Weather class="icon-weather" v-if="weatherUrl != ''" :weatherSrc="weatherUrl"/>
      </div>

      <v-btn text plain :ripple="false" class="d-flex align-center fs-14 px-0 mt-2" @click="$emit('bottomSheetOpen',0)">
        <Question class="me-1"/>
        가장 건강한 나무의 모습은?
      </v-btn>

      <!--      <div class="read-more">자세히 보기<More class="more mt-4 mb-3"/></div>-->
      <div class="read-more">
        <More class="more"/>
      </div>

      <!-- 현재 나의 마음 날씨는? -->
      <h2 class="survey-result-title">현재 나의 마음 날씨는?</h2>

      <div class="survey-result-area">
        <div class="weather-area">
          <Weather class="icon-weather" v-if="weatherUrl != ''" :weatherSrc="weatherUrl"/>
          <div class="state">{{ state }}</div>
        </div>

        <ul>
          <li v-for="n in weatherDescription.length" :key="n">
            {{ weatherDescription[n - 1] }}
          </li>
          <li v-if="addSentenceYn === 'Y'">
            혹시 최근 트라우마(충격적인 경험)을 했거나, 감당하기 어려운 수준의 심리적 어려움을 경험하고 계신 것 같아 걱정이에요. 그럴 때는 의사의 진료나 전문가와의 심리상담이 꼭 필요해요. 전문가에게
            도움을 요청하세요!
          </li>
        </ul>
      </div>

      <div class="result-list">
        <dl v-for="n in weatherEmotion.length" :key="n"
             v-ripple
             class="result-list-item"
             @click="$emit('bottomSheetOpen', 1, weatherEmotion[n - 1])"
        >
          <dt class="tit">
            {{ weatherEmotion[n - 1].emotion }}
          </dt>
          <dd class="tit-icon">
            <EmotionIocn :state="iconSet(n - 1)"/>
          </dd>
          <dd class="state">
            {{ weatherEmotion[n - 1].state }}
          </dd>
          <dd class="state-icon">
            <StateIocn :state="weatherEmotion[n - 1].state" class="img" />
          </dd>
        </dl>
      </div>
    </v-container>

    <v-container fluid >
      <!-- 내 마음 속 나무 -->
      <h2 class="survey-result-title">내 마음 속 나무</h2>

      <div class="survey-result-area">
        <div class="tree-area">
          <Tree v-if="treeUrl != ''" :treeSrc="treeUrl" height="105" width="300" contain />
          <!-- <v-img v-if="treeUrl != ''" :src="getImage(treeUrl)" max-width="300px" max-height="105" contain class="mx-auto"></v-img> -->
          <div class="state">{{ tree }}</div>
        </div>

        <ul>
          <li v-for="n in treeDescription.length" :key="n">
            {{ treeDescription[n - 1] }}
          </li>
        </ul>
      </div>

      <div class="result-list">
        <dl v-for="n in treeEmotion.length" :key="n"
            v-ripple
            class="result-list-item"
            @click="$emit('bottomSheetOpen', 2, treeEmotion[n - 1])"
        >
          <dt class="tit">{{ treeEmotion[n - 1].emotion }}</dt>
          <dd class="tit-icon py-0">
            <v-img :src="getImage(treeEmotion[n - 1].icon)" width="60px" />
          </dd>
          <dd class="state">{{ treeEmotion[n - 1].state }}</dd>
          <dd class="state-icon">
            <StateIocn :state="treeEmotion[n - 1].state" class="img" />
          </dd>
        </dl>
      </div>
    </v-container>
      <!-- 여행종료 후 여행가방에서 진입한 결과페이지 버튼-->
      <v-footer v-if="isSuitcase === true && useOrdDtlIsNull" app fixed grow color="white" class="content-footer">
        <div class="content-buttons">
          <v-btn v-if="noGuide === true" x-large depressed color="primary" class="btn-basic" @click="ticketGo">확인</v-btn>
          <BlackBtn x-large v-else :str="`확인`" @click="ticketGo"/>
          <v-btn v-if="noGuide === true && this.isSuitcase && this.isMyTree"
                 x-large depressed color="primary" :class="isSamsungFire ? 'btn-ok' : 'btn-cancel'"
                 @click="goTravelPage('RR')">여행지원서 새로작성하기
          </v-btn>
        </div>
      </v-footer>
      <!-- 신규여행지원서 작성후 가이드배정전 결과페이지 버튼-->
      <v-footer v-else-if="travelYn !== 'Y' && (isSuitcase !== true || noGuide === true)" app fixed color="white" class="content-footer">
        <div class="footer-btns">
          <BlackBtn x-large :str="`확인`" @click="ticketGo"/>
        </div>
      </v-footer>

  </v-layout>
</template>
<script>
import store from '@/store'
import {mixinAuth, mixinRemote, mixinTicket} from "@/mixins";
// import Arrow from "@/components/icons/Arrow";
import Question from "@/components/icons/QuestionMark";
import EmotionIocn from "@/components/icons/EmotionIocn";
import StateIocn from "@/components/icons/StateIocn";
import BlackBtn from "@/components/btns/BlackBtn";
import Tree from "@/components/icons/Tree";
import Weather from "@/components/icons/Weather";
import More from "@/components/icons/More";
import moment from "moment";
//import FooterBtns from '@/components/btns/FooterBtns'
export default {
  components: {
    Question,
    StateIocn,
    EmotionIocn,
    // Arrow,
    BlackBtn,
    Tree,
    Weather,
    More,
  },
  mixins: [mixinAuth, mixinRemote, mixinTicket],
  props: ["travelApplNo", "unitNo", "travelApplStepCd", "memberStepApplCnt", "isTravelMap", "isSuitcase", "isMyTree"],
  data: () => ({
    selectedResult: 1,
    fromRouter: null,
    name: "",
    state: "",
    tree: "",
    weatherDescription: [],
    treeUrl: "",
    weatherEmotion: [],
    treeDescription: [],
    treeEmotion: [],
    addSentenceYn: "",
    weatherUrl: "",
    memberNo: 0,
    // nickname:'',
    noGuide: false,
    lastTravelApplStepCd: '',
    travelHistoryList: [],
    ticketList: []
  }),
  computed: {
    memberGb() {
      return store.state.auth.authUser.memberGb
    },
    regDt() {
      if (this.travelHistoryList.length > 0 && this.travelHistoryList !== null && this.travelHistoryList !== undefined) {
        return moment(this.travelHistoryList.filter(t => t.travelApplStepCd === this.travelApplStepCd)[0].regDt).format('YYYY.MM.DD')
      } else {
        return ''
      }
    },
    showTravelBtn() {
      //중간, 사후검사 존재 확인
      return this.travelHistoryList.filter(t => t.travelApplStepCd === '0002' || t.travelApplStepCd === '0003').length > 0
              && this.$route.query.showType !== 'FEEDBACK'
    }
  },
  async created() {
    await store.dispatch('getUseOrdDtl', true)
    this.memberNo = store.getters.userKey
    this.name = store.getters.userName
  },
  async mounted() {
    this.getMindStat(this.travelApplStepCd)
    await store.dispatch('getUseOrdDtl', true)

    this.getUseOrdDtlNoGuide()
    this.getMemberApplResultLast()
    this.getTravelMemberHistoryList()
  },
  methods: {
    getMindStat(travelApplStepCode) {
      this.getApplResultForWeatherStatus(travelApplStepCode);
      this.getApplResultForWeatherStat(travelApplStepCode);
      this.getApplResultForTreeStat(travelApplStepCode);
      this.getApplResultForTreeTotal(travelApplStepCode);
    },
    iconSet(n) {
      let _state = this.weatherEmotion[n].areaCritStatus; // 안정: 01, 주의: 03, 위험: 04
      if (_state === "01") {
        return 0;
      } else if (_state === "03") {
        return 1;
      } else if (_state === "04") {
        return 2;
      }
    },
    ticketGo() {
      if (this.isTravelMap) {
        if (this.$route.query.ordDtlNo !== undefined) {
          this.$router.push({name: '여행지도', params: {beforeOrdDtlNo: this.$route.query.ordDtlNo}})
        } else {
          this.prevPage()
        }
      } else if (this.isSuitcase) {
        if (this.$route.query.ordDtlNo !== undefined) {
          this.$router.push({name: '여행지도', params: {beforeOrdDtlNo: this.$route.query.ordDtlNo}})
        } else {
          this.prevPage()
        }
        // this.$router.push({ name: "여행가방"});
      } else {
        if(this.isSamsungFire){
          // 이용중인 티켓이 있는지 확인
          this.getFireTicketList().then(() => {
            let ticketLists = this.ticketList.filter(x=>x.ticketState === '03')
            if (ticketLists.length > 0) {
              this.$router.push({name: "티켓 선택", query: {'first': 'first'}});
            } else {
              this.movePage('/') // 이용중인 티켓이 없으면 메인 페이지로
            }
          })
        } else {
          if(this.memberGb == '02'){
            this.$router.push({name: "티켓 선택 EZN", query: {'first': 'first'}});
          } else {
            // 이용중인 티켓이 있는지 확인
            this.getTicketList().then(() => {
              let ticketLists = this.ticketList.filter(x=>x.ticketState === '03')
              if (ticketLists.length > 0) {
                this.$router.push({name: "티켓 선택 EZN", query: {'first': 'first'}});
              } else {
                this.movePage('/') // 이용중인 티켓이 없으면 메인 페이지로
              }
            })
          }
        }
      }
    },
    goTravelPage(type, cd) {
      // travelApplStepCd = 사전검사(0001), 중간검사(0002), 사후검사(0003)
      // startType = 단계별 처음(S), 단계별 다시시작(R)
      // 단계별 다시시작은 각 검사 단계의 결과까지 보았으나 다시 검사를 하는 경우 사용한다.

      let travelApplStepCd = this.travelApplStepCd

      if (cd != '' && cd != undefined) {
        travelApplStepCd = cd
      }

      if (type == 'RR') {
        this.$router.push({
          name: "blank",
          params: {travelApplStepCd: travelApplStepCd, startType: type, isSuitcase: true}
        });
      } else {
        if (cd !== this.travelApplStepCd) {
           this.getMindStat(travelApplStepCd);
          //
          // const queryMap = Object.fromEntries(
          //   Object.entries({
          //       travelApplStepCd,
          //       startType: type,
          //       isSuitcase: this.$route.query.isSuitcase,
          //       isTravelMap: this.$route.query.isTravelMap,
          //       ordDtlNo: this.$route.query.ordDtlNo
          //     }
          //   // eslint-disable-next-line no-unused-vars
          //   ).filter(([key, value]) => value !== undefined)
          // );
          // const params = new URLSearchParams(queryMap).toString();
          // console.log(params);
          // window.location.href = `/user/travelApplication/intro?${params}`;
          // this.$router.replace({
          //   name: "travelIntro",
          //   query: {
          //     travelApplStepCd: travelApplStepCd,
          //     startType: type,
          //     isSuitcase: this.$route.query.isSuitcase,
          //     isTravelMap: this.$route.query.isTravelMap,
          //     ordDtlNo: this.$route.query.ordDtlNo
          //   }
          // });

          // this.$router.replace({
          //   name: "travelIntro",
          //   query: {
          //     travelApplStepCd: travelApplStepCd,
          //     startType: type,
          //     isSuitcase: this.$route.query.isSuitcase,
          //     isTravelMap: this.$route.query.isTravelMap,
          //     ordDtlNo: this.$route.query.ordDtlNo
          //   }
          // });
        }
      }
    },
    async getApplResultForWeatherStatus(travelApplStepCd) {  // 여행지원서 마음날씨 구분 값 조회 Api
      await store.dispatch('getApplResultForWeatherStatus', this.$_payload('so', [
        {travelApplNo: this.travelApplNo},
        {unitNo: this.unitNo},
        {travelApplStepCd: travelApplStepCd},
        {memberStepApplCnt: this.memberStepApplCnt},
        {memberNo: this.memberNo},
        {areaCritType: '01'},
        {areaCrit: '00'},
      ]))
          .then(res => {
            if (res.success) {
              this.state = res.data.state;
              this.weatherUrl = res.data.imgPath;
              this.weatherDescription = res.data.statusItpt.split('|');
              this.addSentenceYn = res.data.addSentenceYn;
            } else {
              console.log(res.msg)
              this.state = "";
            }
          })
          .catch(error => {
            console.error(error)
            this.state = "";
          })
          .finally(() => {
          })
    },
    async getApplResultForWeatherStat(travelApplStepCd) {  // 여행지원서 마음날씨 영역별 결과 조회 Api
      await store.dispatch('getApplResultForWeatherStat', this.$_payload('so', [
        {travelApplNo: this.travelApplNo},
        {unitNo: this.unitNo},
        {travelApplStepCd: travelApplStepCd},
        {memberStepApplCnt: this.memberStepApplCnt},
        {memberNo: this.memberNo}
      ]))
          .then(res => {
            if (res.success) {
              this.weatherEmotion = res.data;
              this.getApplResultForEmotionValue(travelApplStepCd);
            } else {
              console.log(res.msg)
              this.weatherEmotion = [];
            }
          })
          .catch(error => {
            console.error(error)
            this.weatherEmotion = [];
          })
          .finally(() => {
          })
    },
    async getApplResultForTreeStat(travelApplStepCd) {  // 여행지원서 마음나무 영역별 결과 조회 Api
      await store.dispatch('getApplResultForTreeStat', this.$_payload('so', [
        {travelApplNo: this.travelApplNo},
        {unitNo: this.unitNo},
        {travelApplStepCd: travelApplStepCd},
        {memberStepApplCnt: this.memberStepApplCnt},
        {memberNo: this.memberNo}
      ]))
          .then(res => {
            if (res.success) {
              this.treeEmotion = res.data;
            } else {
              console.log(res.msg)
              this.treeEmotion = [];
            }
          })
          .catch(error => {
            console.error(error)
            this.treeEmotion = [];
          })
          .finally(() => {
          })
    },
    async getApplResultForTreeTotal(travelApplStepCd) {  // 여행지원서 마음나무 결과 조회 Api
      await store.dispatch('getApplResultForTreeTotal', this.$_payload('so', [
        {travelApplNo: this.travelApplNo},
        {unitNo: this.unitNo},
        {travelApplStepCd: travelApplStepCd},
        {memberStepApplCnt: this.memberStepApplCnt},
        {memberNo: this.memberNo}
      ]))
          .then(res => {
            if (res.success) {
              this.tree = res.data.mindTreeName;
              this.treeUrl = res.data.imgPath;
              this.treeDescription = res.data.resultItpt.split('|');
            } else {
              console.log(res.msg)
              this.treeEmotion = [];
            }
          })
          .catch(error => {
            console.error(error)
            this.treeEmotion = [];
          })
          .finally(() => {
          })
    },
    async getApplResultForEmotionValue(travelApplStepCd) {  // 여행지원서 감정상태 조회 Api
      await store.dispatch('getApplResultForEmotionValue', this.$_payload('so', [
        {'travelApplNo': this.travelApplNo},
        {'unitNo': this.unitNo},
        {'travelApplStepCd': travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt},
        {'memberNo': this.memberNo}
      ]))
          .then(res => {
            if (res.success) {
              let valueListFor80 = [];
              let valueListFor90 = [];
              let valueListFor100 = [];
              let nameList = [];
              for (const obj of res.data) {
                if (obj.value <= 80) {
                  valueListFor80.push(obj.cdNm);
                } else if (obj.value >= 90) {
                  valueListFor90.push(obj.cdNm);
                }
                if (obj.value == 100) {
                  valueListFor100.push(obj.cdNm);
                }
                nameList.push(obj.cdNm);
              }

              let makeEmotionStatusItpt = "";
              if (valueListFor80.length === 3) {
                makeEmotionStatusItpt = '최근 2주간 ' + '"' + valueListFor80 + '"' + ' 감정을 다소 경험하고 있는 것처럼 보여요.'
              } else if (valueListFor90.length === 3) {
                makeEmotionStatusItpt = '최근 2주간 ' + '"' + valueListFor90 + '"' + ' 감정을 상당히 경험하고 있는 것처럼 보여요.'
              } else {
                makeEmotionStatusItpt = '최근 2주간 ' + '"' + valueListFor80 + '"' + ' 감정을 다소 경험하고, ' + '"' + valueListFor90 + '"' + ' 감정을 상당히 경험하고 있는 것처럼 보여요.'
              }

              makeEmotionStatusItpt += '|모든 감정에는 목적이 있어 ' + this.nickname + '님이 경험하는 ' + '"'+nameList+'"'
                  + " 감정을 무조건적으로 좋고 나쁜 감정으로 단정지을 수 없어요.|예를 들어 '분노'는 마치 부정적인 것처럼 보이지만, 사실은 자신을 보호하고 상황을 바로잡으며 감정을 해소하도록 하는 중요한 감정인 것처럼요.|하지만 특정 감정을 강하게 느낀다면, 특정 감정을 일으키는 지속적인 상황, 해결되지 않는 연결된 문제가 있을 수 있어 생각해볼 필요가 있어요."

              if (valueListFor100.length > 0) {
                makeEmotionStatusItpt += '|혹시 ' + this.nickname + '님이 ' + '"' + valueListFor100 + '"' + ' 감정을 느끼는 상황은 주로 어떤 상황인가요? 혹은 주로 어떤 생각을 하고 있나요?'
              }

              if (this.weatherEmotion.length > 3) {
                this.weatherEmotion[3].statusItpt = makeEmotionStatusItpt;
              }

            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
    },
    // async getUserNickname () {
    //       await store.dispatch('getUserNickname')
    //           .then(res => {
    //           if (res.success) {
    //               this.nickname = res.data;
    //           } else {
    //               console.log(res.msg);
    //               this.nickname = '';
    //           }
    //           })
    //           .catch(error => {
    //           console.error(error);
    //           this.nickname = '';
    //           })
    //           .finally(() => {})
    // },
    async getUseOrdDtlNoGuide() {  // 유저 티켓 사용 API
      await store.dispatch('getUseOrdDtlNoGuide')
          .then(res => {
            if (res.success) {
              if (res.data == null) {
                this.noGuide = true
              }
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {

          })
    },
    async getMemberApplResultLast() { // 여행지원서 마지막 결과 확인
      await store.dispatch('getMemberApplResultLast', this.$_payload('so', [{'travelApplNo': 1}]))
          .then(res => {
            if (res.success) {
              if (res.data != null) {
                this.lastTravelApplStepCd = res.data.travelApplStepCd;
              }
            }
          })
          .catch(() => {
          })
          .finally(() => {
          })
    },
    async getTravelMemberHistoryList () {
      await store.dispatch('getTravelMemberHistoryList', this.$_payload('so', [{'travelApplNo': 1}, {'memberStepApplCnt': this.memberStepApplCnt}]))
          .then(res => {
            if (res.success) {
              this.travelHistoryList = res.data
            }
          })
          .catch(() => {
          })
          .finally(() => {
          })
    }
  },
};
</script>
